import type { IconSvgObject } from './types';

const DotIcon: IconSvgObject = [
  ["path", { d: "M12 11.502V12.002M13 12.002C13 12.5542 12.5523 13.002 12 13.002C11.4477 13.002 11 12.5542 11 12.002C11 11.4497 11.4477 11.002 12 11.002C12.5523 11.002 13 11.4497 13 12.002Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default DotIcon;
